<template>
    <el-dialog title="修改用户" width="70%" :append-to-body="true" :visible.sync="modifyVisible" center v-loading="modifyUserLoading" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" 
    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-form ref="modifyForm" :rules="modifyFormRules" :model="modifyForm" size="mini" label-width="180px">
            <el-form-item label="登录名：">
                <el-tag type="primary" size="mini">{{modifyForm.xmid}}</el-tag>
            </el-form-item>
            <el-form-item label="用户名：" prop="xmname">
                <el-input v-model="modifyForm.xmname" placeholder="用户名" :maxlength="10" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="权限部门：" prop="bmList">
                <el-select v-model="modifyForm.bmIdList" placeholder="权限部门"  multiple>
                    <el-option v-for="item in bmList" :key="item.clid" :label="item.clname" :value="item.clid"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户角色：" prop="roleList">
                <div class="roleDiv">
                    <el-transfer v-model="modifyForm.roleList" :data="roleList" :props="{key: 'roleId',label: 'roleName'}"
                    :titles="['未含角色', '已含角色']"  :format="{noChecked: '${total}',hasChecked: '${checked}/${total}' }"
                    >
                        <span slot-scope="{ option }">
                        <el-tooltip :content="option.roleName+':('+option.description+')'" placement="right" effect="light">
                            <span>{{ option.roleName }}</span> 
                        </el-tooltip>
                        </span>
                    </el-transfer>
                    <el-button type="primary" plain size="mini" v-show="canAddRole" @click="changeRoleVisible(true)"><i class="el-icon-plus"></i>&nbsp; 添加角色</el-button>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="modifyUser">提交</el-button>
        </span>

        <!--添加角色-->
        <new-role 
        :newRoleVisible="newRoleVisible"
        :flushRoleList="flushRoleList" 
        :rightList="rightList" 
        @changeVisible="changeRoleVisible"
        ></new-role>
    </el-dialog>
</template>
<script>
import NewRole from '../role/NewRole.vue'
export default {
    components: { NewRole },
    name:'ModifyUser',
    props:{
        roleList:Array,
        bmList:Array,
        rightList:Array,

        modifyVisible:Boolean,
        modifyFormCp:Object,

        flushUserList:Function,
        flushRoleList:Function,
        canAddRole:{type:Boolean,default:false}
    },
    data(){
        return {
            modifyUserLoading:false,
            modifyForm:{
                xmid:"",xmname:"",bmIdList:[],roleList:[]
            },
            modifyFormRules:{
                xmname:[{required:true,message:"用户名称必填",trigger:'blur'}],
                roleList:[{ type: 'array', required: true, message: '至少需要1个角色', trigger: 'change' }]
            },

            newRoleVisible:false,
        }
    },
    mounted(){},
    methods:{
        changeRoleVisible(val){
            this.newRoleVisible=val
        },
        close(){
            this.$emit('changeVisible',false)
        },
        modifyUser(){
            this.$refs.modifyForm.validate(async valid=>{
                if(valid){
                    const confirmresult = await this.$confirm('将要修改该用户的相关信息，请确定是否继续？','提示',{
                        confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'
                    }).catch(err=>err)
                    if(confirmresult!=='confirm'){
                        return this.$message.info('已取消操作')
                    }else{
                        this.modifyUserLoading=true
                        const {data:res}=await this.$http.post('um/change',this.modifyForm).catch(err => err)
                        if(res){
                            this.$message.success('操作成功！')
                            this.flushUserList()
                            this.close()
                        }
                        this.modifyUserLoading=false
                    }
                }else{
                    return false
                }
            })
        },
    },
    watch:{
        modifyFormCp(n){
            this.modifyForm=n
        }
    }
}
</script>
<style scope>
.el-transfer-panel{
    width: 280px;
    }
    .el-transfer-panel__list.is-filterable{
    height: 280px;
    }
    .roleDiv{
        display: flex;
        justify-content:space-between ;
    }
</style>